import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import HomePage from './pages/HomePage';
import SearchResultsPage from './pages/SearchResultsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import UploadReceiptPage from './pages/UploadReceiptPage';
import StoreListPage from './pages/StoreListPage';
import ProfilePage from './pages/ProfilePage';
import AboutPage from './pages/AboutPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import StoreDetailPage from './pages/StoreDetailPage';
import BasketsPage from './pages/BasketsPage';
import BasketDetailPage from './pages/BasketDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import { BasketProvider } from './context/BasketContext';
import InstallPrompt from './components/InstallPrompt';

function ProtectedRoute({ children }) {
  const { isAuthenticated, authLoading } = useAuth();
  if (authLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <BasketProvider>
          <div className="min-h-screen flex flex-col bg-gray-50">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path='/' element={<HomePage />} />
                <Route path='/search' element={<SearchResultsPage />} />
                <Route path='/product/:productIdentifier' element={<ProductDetailPage />} />
                <Route path='/upload' element={<ProtectedRoute><UploadReceiptPage /></ProtectedRoute>} />
                <Route path='/stores/:storeIdentifier' element={<StoreDetailPage />} />
                <Route path='/stores' element={<StoreListPage />} />
                <Route path='/baskets' element={<ProtectedRoute><BasketsPage /></ProtectedRoute>} />
                <Route path='/baskets/:id' element={<ProtectedRoute><BasketDetailPage /></ProtectedRoute>} />
                <Route path='/profile' element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
                <Route path='/about' element={<AboutPage />} />
                <Route path='/login' element={<LoginPage />} />
                <Route path='/register' element={<RegisterPage />} />
                <Route path='/forgot-password' element={<ForgotPasswordPage />} />
                <Route path='*' element={<NotFoundPage />} />
              </Routes>
            </main>
            <footer className="bg-white py-5 text-center text-gray-400 text-xs border-t mt-auto pb-20 md:pb-5">
              &copy; {new Date().getFullYear()} BoVi Price. All rights reserved.
              <span className="mx-2">&middot;</span>
              <a href="/about" className="hover:text-red-800 transition">About</a>
            </footer>
            <BottomNav />
            <InstallPrompt />
          </div>
        </BasketProvider>
      </AuthProvider>
    </Router>
  );
}
